if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        if (this._hasChangeListener) {
          return;
        }

        this._hasChangeListener = true;

        this.addEventListener(
          'change',
          (event) => {
            // Check if target is inside this element
            const targetInThisElement = this.contains(event.target);

            // Check if there's a nested variant-selects between this and target
            let hasNestedVariantSelects = false;
            let currentElement = event.target;

            while (currentElement && currentElement !== document.body) {
              if (currentElement.tagName === 'VARIANT-SELECTS') {
                if (currentElement !== this) {
                  hasNestedVariantSelects = true;
                  break;
                } else {
                  break;
                }
              }
              currentElement = currentElement.parentElement;
            }

            // Ignore if target is not in this element or there's a nested variant-selects
            if (!targetInThisElement || hasNestedVariantSelects) {
              return;
            }

            const target = this.getInputForEventTarget(event.target);
            this.updateSelectedSwatchValue(event);
            // Drivos 14.10.2026: riippuva valinta (esim. malli) automaattisesti, jos sitä on vain yksi
            const drivosResolved = this.drivosResolveOptionValues(target);
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
              data: {
                event,
                target,
                selectedOptionValues: drivosResolved || this.selectedOptionValues,
              },
            });
          },
          true
        ); // Use CAPTURE phase to catch events before they bubble
      }

      /*
       * Drivos 14.10.2026: tuotteille, joissa ei ole värivalintaa (esim. telamatto: Koko + Malli).
       * Data tulee product-variant-pickeristä ([data-drivos-variant-options]), jota ei tulosteta
       * väri+koko-tuotteille, joten niissä tämä ei tee mitään.
       * Jos valittu yhdistelmä ei ole olemassa, jokaiselle muulle kuin klikatulle valinnalle etsitään
       * arvot, jotka sopivat muihin valintoihin. Jos sopivia on täsmälleen yksi, se valitaan.
       * Palauttaa option value ID:t tai null (jolloin teeman oma käytös säilyy).
       */
      drivosResolveOptionValues(target) {
        try {
          const dataEl = this.querySelector('[data-drivos-variant-options]');
          if (!dataEl || !target || target.tagName !== 'INPUT') return null;
          const data = JSON.parse(dataEl.textContent);
          const options = data.options || [];
          const variants = data.variants || [];
          const fieldsets = Array.from(this.querySelectorAll('fieldset.product-form__input'));
          if (fieldsets.length !== options.length || options.length < 2) return null;

          const selected = fieldsets.map((fs) => {
            const input = fs.querySelector('input:checked');
            return input ? input.value : null;
          });
          const isFull = (vals) => vals.every((v) => v !== null) && variants.some((v) => vals.every((val, i) => v[i] === val));
          if (isFull(selected)) return null;

          const clickedIdx = fieldsets.findIndex((fs) => fs.contains(target));
          const out = selected.slice();
          out.forEach((_, idx) => {
            if (idx === clickedIdx || isFull(out)) return;
            const candidates = options[idx].filter((opt) =>
              variants.some((v) => v[idx] === opt.n && out.every((val, j) => j === idx || val === null || v[j] === val))
            );
            if (candidates.length === 1) out[idx] = candidates[0].n;
          });
          if (!isFull(out)) return null;

          return out.map((name, i) => {
            const opt = options[i].find((o) => o.n === name);
            return opt ? String(opt.id) : null;
          });
        } catch (e) {
          return null;
        }
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
